import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { reactive, ref } from "vue";
import API from "@/api";
import { aiGenerateQuestionUsingPost } from "@/api/questionController";
import message from "@arco-design/web-vue/es/message";
import { EventSourcePolyfill } from "event-source-polyfill";

interface Props {
  appId: string;
  onSuccess?: (result: API.QuestionContentDTO[]) => void;
  onSSESuccess?: (result: API.QuestionContentDTO) => void;
  onSSEStart?: (event: any) => void;
  onSSEClose?: (event: any) => void;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'AiGenerateQuestionDrawer',
  props: {
    appId: { default: () => {
    return "";
  } },
    onSuccess: {},
    onSSESuccess: {},
    onSSEStart: {},
    onSSEClose: {}
  },
  setup(__props: any) {

const props = __props;

const form = reactive({
  optionNumber: 2,
  questionNumber: 10,
} as API.AiGenerateQuestionRequest);

const visible = ref(false);
const submitting = ref(false);
const sseSubmitting = ref(false);

const handleClick = () => {
  visible.value = true;
};
const handleOk = () => {
  visible.value = false;
};
const handleCancel = () => {
  visible.value = false;
};

/**
 * 提交
 */
const handleSubmit = async () => {
  if (!props.appId) {
    return;
  }
  submitting.value = true;
  const res = await aiGenerateQuestionUsingPost({
    appId: props.appId as any,
    ...form,
  });
  if (res.data.code === 0 && res.data.data.length > 0) {
    if (props.onSuccess) {
      props.onSuccess(res.data.data);
    } else {
      message.success("生成题目成功");
    }
    // 关闭抽屉
    handleCancel();
  } else {
    message.error("操作失败，" + res.data.message);
  }
  submitting.value = false;
};

/**
 * 提交（实时生成）
 */
const handleSSESubmit = async () => {
  if (!props.appId) {
    return;
  }
  sseSubmitting.value = true;
  // 创建 SSE 请求
  const url = `http://localhost:8101/api/question/ai_generate/sse?appId=${props.appId}&optionNumber=${form.optionNumber}&questionNumber=${form.questionNumber}`;

  // 使用 Polyfill 替代原生 EventSource
  const eventSource = new EventSourcePolyfill(url, {
    withCredentials: true, // ✅ 携带 Cookie
    headers: {
      Accept: "text/event-stream",
    },
  });
  let first = true;
  // 添加关闭事件监听
  eventSource.addEventListener("close", function (event) {
    console.log("SSE 连接正常关闭");
    props.onSSEClose?.(event);
    eventSource.close();
    sseSubmitting.value = false;
    return;
  });
  // 接收消息
  eventSource.onmessage = function (event) {
    if (first) {
      props.onSSEStart?.(event);
      handleCancel();
      first = false;
    }
    try {
      const data = JSON.parse(event.data);
      props.onSSESuccess?.(data);
    } catch (e) {
      console.error("解析消息失败:", event.data);
    }
  };
  // 报错或连接关闭时触发
  eventSource.onerror = function (event: any) {
    const readyState = event.target.readyState;

    // 连接正常关闭（服务端完成推送）
    // if (readyState === EventSourcePolyfill.CLOSED) {
    //   console.log("连接正常关闭");
    //   props.onSSEClose?.(event);
    //   sseSubmitting.value = false;
    //   return;
    // }

    // 连接异常（正在重连）
    if (readyState === EventSourcePolyfill.CONNECTING) {
      console.log("连接异常，正在重连");
      message.error("生成过程出错，请重试");
      eventSource.close();
      sseSubmitting.value = false;
      return;
    }

    // 连接已打开但出错
    if (readyState === EventSourcePolyfill.OPEN) {
      console.log("连接已打开但出错");
      message.error("生成过程出错");
      eventSource.close();
      sseSubmitting.value = false;
      return;
    }

    // 其他未知错误
    console.error("未知连接错误:", event);
    eventSource.close();
    sseSubmitting.value = false;
  };
};

return (_ctx: any,_cache: any) => {
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_input_number = _resolveComponent("a-input-number")!
  const _component_a_space = _resolveComponent("a-space")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_drawer = _resolveComponent("a-drawer")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_a_button, {
      type: "outline",
      onClick: handleClick
    }, {
      default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
        _createTextVNode("AI 生成题目", -1)
      ]))]),
      _: 1
    }),
    _createVNode(_component_a_drawer, {
      visible: visible.value,
      width: 340,
      onCancel: handleCancel,
      onOk: handleOk,
      unmountOnClose: ""
    }, {
      title: _withCtx(() => [...(_cache[3] || (_cache[3] = [
        _createTextVNode(" AI 生成题目", -1)
      ]))]),
      default: _withCtx(() => [
        _createElementVNode("div", null, [
          _createVNode(_component_a_form, {
            model: form,
            "auto-label-width": "",
            "label-align": "left",
            onSubmit: handleSubmit
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_form_item, { label: "应用 id" }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(__props.appId), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_a_form_item, {
                field: "questionNumber",
                label: "题目数量"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_input_number, {
                    modelValue: form.questionNumber,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((form.questionNumber) = $event)),
                    max: 20,
                    min: 0,
                    placeholder: "请输入题目数量"
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_a_form_item, {
                field: "optionNumber",
                label: "选项数量"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_input_number, {
                    modelValue: form.optionNumber,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((form.optionNumber) = $event)),
                    max: 6,
                    min: 0,
                    placeholder: "请输入选项数量"
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_a_form_item, null, {
                default: _withCtx(() => [
                  _createVNode(_component_a_space, {
                    style: {"margin-left":"-40px"},
                    size: "large"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_button, {
                        loading: submitting.value,
                        "html-type": "submit",
                        style: {"width":"120px"},
                        type: "primary"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(submitting.value ? "生成中" : "一键生成"), 1)
                        ]),
                        _: 1
                      }, 8, ["loading"]),
                      _createVNode(_component_a_button, {
                        loading: sseSubmitting.value,
                        style: {"width":"120px"},
                        onClick: handleSSESubmit
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(sseSubmitting.value ? "生成中" : "实时生成"), 1)
                        ]),
                        _: 1
                      }, 8, ["loading"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["model"])
        ])
      ]),
      _: 1
    }, 8, ["visible"])
  ], 64))
}
}

})